// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./malquerida.jpg')
const allTwoEs = require('./animated-1.gif')
const allTwoCa = require('./animated-1-Ca.gif')
const allFourEs = require('./static-1.png')
const allFourCa = require('./static-1-Ca.png')
const catalogTwoEs = require('./static-1.png')
const catalogTwoCa = require('./static-1-Ca.png')
const catalogFourEs = require('./static-1.png')
const catalogFourCa = require('./static-1-Ca.png')

const model = creativityMediaModel({
  catalogID: 'beer',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
